import React, { useState, useEffect } from "react";
import AvgEtc from "./AvgEtc";
import LoadingLogTable from "./LoadingLogTable";
import { useVoyageContextV2 } from "../../Contexts/VoyageContextV2"; // V2!
import { useCompanyContext } from "../../Contexts/CompanyContext";
import VoyageCargoInfoTable from "../pumplogging/VoyageCargoInfoTable";
import { getSelectedCargo, getSelectedTrip } from "../../utils/voyageSelection";

const LoadLog = () => {
  const {
    selectedTripId,
    selectedCargoIndex,
    currentVoyage,
    isVoyageReadOnly,
    updateTripCargo,
  } = useVoyageContextV2();

  const trip = getSelectedTrip(currentVoyage, selectedTripId) || {};
  const cargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );
  const loadingLogRates = cargo?.loadingLogRates;

  const { companyLogo } = useCompanyContext();

  // States
  const [avgRate, setAvgRate] = useState(0);
  const [lastAvgRate, setLastAvgRate] = useState(0);
  const [etcAvg, setEtcAvg] = useState(0);
  const [etcCurrent, setEtcCurrent] = useState(0);
  const [manifolds, setManifolds] = useState("");
  const [connectionSize, setConnectionSize] = useState("");
  const [isLocked, setIsLocked] = useState(true);

  useEffect(() => {
    const rates = loadingLogRates || {};
    setAvgRate(rates.avgRate || 0);
    setLastAvgRate(rates.lastAvgRate || 0);
    setEtcAvg(rates.etcAvg || 0);
    setEtcCurrent(rates.etcCurrent || 0);
    setManifolds(rates.manifolds || "");
    setConnectionSize(rates.connectionSize || "");
    // Lås om det finns data, annars håll öppet
    setIsLocked(Boolean(rates.manifolds));
  }, [loadingLogRates]);

  const handleLock = async () => {
    if (isVoyageReadOnly) return;
    if (!isLocked) {
      if (!cargo?.cargoId) return;

      await updateTripCargo(
        cargo.cargoId,
        {
          loadingLogRates: {
            ...(cargo.loadingLogRates || {}),
          manifolds,
          connectionSize,
          avgRate,
          lastAvgRate,
          etcAvg,
          etcCurrent,
          },
        },
        { summary: "Updated loading log rates" }
      );
    }
    setIsLocked(!isLocked);
  };
  return (
    <>
      <VoyageCargoInfoTable
        currentVoyage={currentVoyage}
        trip={trip}
        cargo={cargo}
        avgRate={avgRate}
        lastAvgRate={lastAvgRate}
        etcAvg={etcAvg}
        etcCurrent={etcCurrent}
        manifolds={manifolds}
        connectionSize={connectionSize}
        setManifolds={setManifolds}
        setConnectionSize={setConnectionSize}
        isLocked={isLocked}
        handleLock={handleLock}
        readOnly={isVoyageReadOnly}
        selectedTripId={selectedTripId}
        selectedCargoIndex={selectedCargoIndex}
        companyLogo={companyLogo}
        isLoadLog={true}
      />

      <AvgEtc
        avgRate={avgRate}
        lastAvgRate={lastAvgRate}
        etcAvg={etcAvg}
        etcCurrent={etcCurrent}
      />

      <LoadingLogTable
        lastAvgRate={lastAvgRate}
        avgRate={avgRate}
        etcAvg={etcAvg}
        etcCurrent={etcCurrent}
        setAvgRate={setAvgRate}
        setLastAvgRate={setLastAvgRate}
        setEtcAvg={setEtcAvg}
        setEtcCurrent={setEtcCurrent}
        // Tips: Skicka även med update-funktioner här om LoadingLogTable ska spara direkt
      />
    </>
  );
};

export default LoadLog;
